export const isValidDate = date => {
  if (typeof date === "string") {
    return !isNaN(new Date(date).getTime());
  }
  return date && date.constructor === Date && !isNaN(date.getTime());
};

export const cloneDate = date => new Date(date);

export const cloneIfValidElseNow = date =>
  isValidDate(date) ? cloneDate(date) : new Date();

const addToDate = (n, date, method) => {
  const newDate = cloneIfValidElseNow(date);
  newDate[`set${method}`](newDate[`get${method}`]() + n);
  return newDate;
};

export const addDay = (dayN, date) => addToDate(dayN, date, "Date");
export const addMonth = (monthN, date) => addToDate(monthN, date, "Month");

export const startOfDay = date => {
  const newDate = cloneIfValidElseNow(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};
export const endOfDay = date => {
  const newDate = cloneIfValidElseNow(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
};

export const maxDateSymbol = Symbol("maxDate");
export const minDateSymbol = Symbol("minDate");

export const INVALID_DATE = "Invalid Date";

export const MAXIMUM_DATE = new Date(8640000000000000);
export const MINIMUM_DATE = new Date(-8640000000000000);
